(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurator-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initConfiguratorTeaser(root) {
      var wash = root.querySelector('.configurator-teaser__wash');
      var swatches = root.querySelectorAll('.configurator-teaser__swatch');

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatches.forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');
          if (wash) wash.style.background = 'rgb(' + swatch.dataset.rgb + ')';
        });
      });
    }

    document.querySelectorAll('.configurator-teaser').forEach(initConfiguratorTeaser);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.configurator-teaser');
      if (section) initConfiguratorTeaser(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-veil"] && !Shopify.designMode) return;
  try {
    
  (function () {
    sessionStorage.setItem('veluno:introSeen', '1');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initManifestoEmbers(canvas) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var ctx = canvas.getContext('2d');
      var baseCount = Number(canvas.dataset.count) || 26;
      // Mobile keeps the same ember effect (per brand direction: mobile should
      // match desktop, not a stripped-down version) but at roughly half the
      // particle count, trading a lighter effect for real-device performance.
      var count = isMobile ? Math.round(baseCount / 2) : baseCount;
      var embers = [];
      var rafId = null;
      var seeded = false;

      function resize() {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
      }

      function startLoop() {
        if (rafId === null) animate();
      }

      function seed() {
        embers = Array.from({ length: count }, function () {
          return {
            x: Math.random() * canvas.width,
            y: canvas.height + Math.random() * canvas.height,
            r: 1.5 + Math.random() * 2.5,
            speed: 0.25 + Math.random() * 0.5,
            drift: (Math.random() - 0.5) * 0.4,
            alpha: 0.3 + Math.random() * 0.5,
          };
        });
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        embers.forEach(function (p) {
          p.y -= p.speed;
          p.x += p.drift;
          if (p.y < -10) {
            p.y = canvas.height + 10;
            p.x = Math.random() * canvas.width;
          }
          ctx.beginPath();
          var grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
          grad.addColorStop(0, 'rgba(227,201,137,' + p.alpha + ')');
          grad.addColorStop(1, 'rgba(227,201,137,0)');
          ctx.fillStyle = grad;
          ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2);
          ctx.fill();
          ctx.beginPath();
          ctx.fillStyle = 'rgba(255,235,200,' + p.alpha + ')';
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fill();
        });
        rafId = requestAnimationFrame(animate);
      }

      // ResizeObserver fires as soon as the canvas has a real, laid-out box
      // (and again on any later resize) — unlike a single offsetWidth/
      // offsetHeight read at script-init time, this can never race ahead of
      // layout and read the pre-layout default (which is how the embers
      // ended up seeded into a 300x150 area pinned to the top-left corner).
      var resizeObserver = new ResizeObserver(function () {
        resize();
        if (!seeded && canvas.width > 0 && canvas.height > 0) {
          seeded = true;
          seed();
          startLoop();
        }
      });
      resizeObserver.observe(canvas);

      // Pause when off-screen (section far from viewport, e.g. deep-scrolled
      // past it) to avoid burning cycles on a canvas nobody can see.
      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && seeded) {
              startLoop();
            } else if (!entry.isIntersecting && rafId !== null) {
              cancelAnimationFrame(rafId);
              rafId = null;
            }
          });
        },
        { threshold: 0 }
      );
      visibilityObserver.observe(canvas);
    }

    document.querySelectorAll('.manifesto__embers').forEach(initManifestoEmbers);

    document.addEventListener('shopify:section:load', function (event) {
      var canvas = event.target.querySelector('.manifesto__embers');
      if (canvas) initManifestoEmbers(canvas);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRitual(root) {
      var sticky = root.querySelector('.ritual__sticky');
      if (!sticky) return;

      var images = sticky.querySelectorAll('.ritual__image');
      var numeral = sticky.querySelector('.ritual__numeral');
      var steps = root.querySelectorAll('.ritual__step');

      function setActive(idx, label) {
        steps.forEach(function (step) {
          step.classList.toggle('is-active', step.dataset.idx === idx);
        });
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.idx === idx);
        });
        if (numeral) {
          var num = String(Number(idx) + 1).padStart(2, '0');
          numeral.textContent = label ? num + ' — ' + label : num;
        }
      }

      // Seed the first chapter immediately so nothing is blank pre-scroll.
      if (steps[0]) setActive(steps[0].dataset.idx, steps[0].dataset.label);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              setActive(entry.target.dataset.idx, entry.target.dataset.label);
            }
          });
        },
        { threshold: [0.5] }
      );

      steps.forEach(function (step) {
        observer.observe(step);
      });
    }

    document.querySelectorAll('.ritual').forEach(initRitual);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.ritual');
      if (section) initRitual(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
